import { IMAGE, VIDEO, AUDIO } from '../../../lib/constants';
import noImageThumbnail from '../../../images/media/noimage.jpg';
import videoFallbackThumbnail from '../../../images/media/img_group_01.svg';
import audioFallbackThumbnail from '../../../images/media/img_group_02.svg';

/**
 * メディアの種類ごとのサムネイル
 * @type {Object}
 * @property {string} noImage - 画像が存在しない場合に表示するサムネイルのURL。
 * @property {string} videoFallback - ビデオのサムネイルが存在しない場合に表示するフォールバックのURL。
 * @property {string} audioFallback - オーディオのサムネイルが存在しない場合に表示するフォールバックのURL。
 */
export const mediaTypeThumbnails = {
  noImage: noImageThumbnail,
  videoFallback: videoFallbackThumbnail,
  audioFallback: audioFallbackThumbnail,
};

/**
 * 表示するアイコンのパスを取得する
 */
export function getMediaIconSrc(mediaType, thumbnailUrl) {
  if (mediaType === VIDEO && !thumbnailUrl) {
    return mediaTypeThumbnails.videoFallback;
  }
  if (mediaType === AUDIO) {
    return mediaTypeThumbnails.audioFallback;
  }
  if (mediaType !== IMAGE && mediaType !== VIDEO && mediaType !== AUDIO) {
    return mediaTypeThumbnails.noImage;
  }

  return thumbnailUrl;
}
